// Firebase Cloud Messaging Configuration File.
// Read more at https://firebase.google.com/docs/cloud-messaging/js/client && https://firebase.google.com/docs/cloud-messaging/js/receive

import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  deleteToken,
} from "firebase/messaging";
// import { tokenRegister } from "../services/requestServices";

// console.log("process", process);

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

let registrationValue = null;

function register() {
  try {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        if ("serviceWorker" in navigator) {
          navigator.serviceWorker
            .register("../firebase-messaging-sw.js", { scope: "/" })
            .then(function (registration) {
              // Successful registration
              console.log(
                "Hooray. Registration successful, scope is:",
                registration.scope
              );
              registrationValue = registration;
            });
        }
      } else {
        console.log("Notification Permission Denied");
      }
    });
  } catch (err) {
    console.log(err);
  }
}

initializeApp(firebaseConfig);
register();

// const handleRegistraion = async (currentToken) => {
//   // setLoader(true);
//   let postData = {
//     token: currentToken,
//   };
//   console.log(postData);
//   try {
//     let response = await tokenRegister(postData);
//     console.log("response", response);
//     if (response.status === 200) {
//       console.log("response", response);
//       // setModal(false);
//       // setDisable(true);
//       // setLoader(false);
//       // fetchBookingDetails(id);
//     }
//   } catch (err) {
//     console.log("error", err);
//     // setModal(false);
//     // setDisable(true);
//     // setLoader(false);
//   }
// };

const messaging = getMessaging();

export const deleteRegToken = async () => {
  const messaging = getMessaging();
  try {
    await deleteToken(messaging).then((currentToken) => {
      console.log(currentToken);
    });
  } catch (err) {
    console.log("err", err);
  }
};

export const requestForToken = async () => {
  register();
  let res;
  const registration = registrationValue;
  if (registration) {
    res = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_VAPIDKEY,
      serviceWorkerRegistration: registration,
    });
    localStorage.setItem("firebaseEmployeeToken", res);
  }
  return res;
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
